<template>
    <BaseModal ref="baseModalRef" v-bind="childProps">
        <template #body>
            <div class="table-responsive table-list">
              <TreeTable ref="treeTableRef" :dataList="treeGirdOptions.menuList" :gridColumn="treeGirdOptions.column" 
              :rootVal="''" :useCheckBox="true" :disabledCheckBox="true" :paginator="false"/>
            </div>
        </template>
    </BaseModal>

</template>

<script setup>
import { reactive, computed, onBeforeMount, ref } from 'vue'
import BaseModal from '@/components/common/modal/BaseModal.vue';
import TreeTable from "@/components/common/TreeTable.vue";
import common from '@/js/common';
import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { getAuthGrpMenuList } from '@/api/userInfo';

const baseModalRef = ref()
const treeTableRef = ref()
const emits = defineEmits(['return'])

const auth_grp_id = ref('') 
const childProps = ref({
    modalId : 'menuAuthModal',
    modalNm : '메뉴 권한보기',
    size:'',
})


const treeGirdOptions = ref({
  menuList : [],
  column : [
    {
        header: '메뉴',
        field: "menu_nm",
        expander: true,
        style: { minWidth: "400px" },
    },
  ]
})

onBeforeMount(async()=>{
    await getMenuList()
})


function openModal(code){
    auth_grp_id.value = code
    showAuthByMenu()
}

function closeModal(){
    baseModalRef.value.closeModal()
}

async function getMenuList(){
  try{
    setIsLoading(true)
    const res = await getAuthGrpMenuList({auth_grp_id: auth_grp_id.value}) 
    treeGirdOptions.value.menuList = [...res.rtn].map((item)=>{
      item['up_menu_id'] = item['upper_menu_id']
      return item
    })
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
  
}

async function showAuthByMenu(){
  if(!auth_grp_id.value){
    alert('권한을 먼저 선택해주세요')
    return
  }

  try{
    setIsLoading(true)
    await getMenuList()
    treeTableRef.value.selectRows = []
    treeGirdOptions.value.menuList.forEach((item)=>{
      if(item.mnu_auth_seq){
        treeTableRef.value.selectRows.push(item.menu_id)
      }
    })
    baseModalRef.value.openModal()

  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}

defineExpose({
    openModal,
})

</script>